import {tabletAndUp} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import headerBackgroundExpanded from '../../backend-services/CouponLandingPage/Header/assets/header-background-expanded.svg';
import {CouponDeepLinkActivationProps} from './CouponDeepLinkActivation';
import {CouponIcon} from './CouponIcon';

export const CouponDeepLinkActivationDesktopHeader: React.FC<
  Pick<CouponDeepLinkActivationProps, 'status'>
> = ({status}) => {
  return (
    <Wrapper>
      <StyledCouponIcon status={status} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: none;
  background: url(${headerBackgroundExpanded}) no-repeat center/cover;

  width: 100%;
  height: 96px;

  ${tabletAndUp(
    css`
      display: flex;
      justify-content: center;
    `,
  )}
`;

const StyledCouponIcon = styled(CouponIcon)`
  position: relative;
  top: 45px;
`;
